export { default } from './Media';
export type { MediaProps, MediaClassKey, MediaClasses } from './Media.types';
